import { render, staticRenderFns } from "./RestBreakScheduleRequest.vue?vue&type=template&id=68ac08bf&"
import script from "./RestBreakScheduleRequest.vue?vue&type=script&lang=js&"
export * from "./RestBreakScheduleRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports